<div class="row" *ngIf="fileData">
    <div class="col-12">

        <div class="card">

            <div class="card-header">
                <div class="title"> {{ 'DATE_FILE' | translate }}</div>
                <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
                    <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
                    [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                </button>
            </div>

            <div class="card-body">
                <div class="row">
                    <div class="col-5 image-box">
                        <div class=" file-img product-img" *ngIf="(fileData.extension == 'jpg' || fileData.extension == 'png' || fileData.extension == 'jpeg' || fileData.extension == 'png') && fileLink != null">
                            <img class="product-img_sze" src="{{ fileLink }}">
                        </div>
                        <div class="product-img block-no-photo" *ngIf="(fileData.extension != 'jpg' && fileData.extension != 'png' && fileData.extension != 'jpeg' && fileData.extension != 'png') || fileLink == null">
                            <img src="/assets/images/icons/no-photo.svg" class="product-img_sze">
                        </div>
                    </div>
                    <div class="col-7 file">

                        <div class="file-info">
                            <div class="block-info">
                                <div class="info-item">
                                    <div class="notification-info-title">{{ 'DENOMINATION_FILE' | translate }}: </div>
                                </div>
                                <div class="info-item">
                                    <div class="org-info-value">{{fileData.name}}</div>
                                </div>
                            </div>
                            <div class="block-info">
                                <div class="info-item">
                                    <div class="notification-info-title">{{ 'FILES.DATE_OF_CREATE' | translate }}: </div>
                                </div>
                                <div class="info-item">
                                    <div class="org-info-value">{{ fileData.create_date | date: 'dd.MM.yyyy HH:mm' }} </div>
                                </div>
                            </div>
                            <div class="block-info">
                                <div class="info-item">
                                    <div class="notification-info-title">{{ 'FILES.CREATER' | translate }}: </div>
                                </div>
                                <div class="info-item">
                                    <div class="org-info-value">{{fileData.create_user}}</div>
                                </div>
                            </div>
                            <div class="block-info">
                                <div class="info-item">
                                    <div class="notification-info-title">{{ 'SIZE' | translate }}: </div>
                                </div>
                                <div class="info-item">
                                    <div class="org-info-value">{{ convertationToMb(fileData.size) }}</div>
                                </div>
                            </div>
                            <div class="block-info">
                                <div class="info-item">
                                    <div class="notification-info-title">{{ 'FORMAT' | translate }}: </div>
                                </div>
                                <div class="info-item">
                                    <div class="org-info-value">{{fileData.extension}}</div>
                                </div>
                            </div>
                            <!-- <div class="block-info">
                                <div class="info-item">
                                    <div class="notification-info-title">{{ 'DOUNLOAD_LINK' | translate }}: </div>
                                </div>
                                <div class="info-item">
                                    <a type="button" class="org-info-value link"
                                        (click)="downloadFile(fileData.file_id, fileData.name)">{{ 'DOWNLOAD_FILE' | translate }}
                                    </a>
                                </div>
                            </div> -->
                            <div class="block-info">
                                <div class="info-item">
                                    <div class="notification-info-title">Срок действия файла: </div>
                                </div>
                                <div class="info-item">
                                    <div class="org-info-value">
                                        <span *ngIf="fileData.meta != null && fileData.meta.valid_to != null">{{ fileData.meta.valid_to | date: 'dd.MM.yyyy'}}</span>
                                        <span *ngIf="fileData.meta == null || fileData.meta.valid_to == null">Нет данных</span>
                                    </div>
                                </div>
                            </div>
                            <div class="block-info">
                                <div class="info-item">
                                    <div class="notification-info-title">Категория: </div>
                                </div>
                                <div class="info-item">
                                    <div class="org-info-value">
                                        <span *ngIf="fileData.category_name != null">{{fileData.category_name}}</span>
                                        <span *ngIf="fileData.category_name == null">Нет данных</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="file-info_btn">
                            <div class="btn-upload-file">
                                <button type="button" class="btn btn-primary btn-sm" (click)="downloadFile(fileData.file_id, fileData.name)">
                                    <svg-icon src="/assets/images/icons/download.svg" [stretch]="true"
                                    [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                    <span>Скачать</span> 
                                </button>
                            </div>
                        </div>


                        <!-- <div class="row">
                            <div class="col-6">
                                <div class="notification-info-title">{{ 'DENOMINATION_FILE' | translate }}: </div>
                            </div>
                            <div class="col-6">
                                <div class="org-info-value">{{fileData.name}}</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <div class="notification-info-title">{{ 'FILES.DATE_OF_CREATE' | translate }}: </div>
                            </div>
                            <div class="col-6">
                                <div class="org-info-value">{{ fileData.create_date | date: 'dd.MM.yyyy HH:mm' }} </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <div class="notification-info-title">{{ 'FILES.CREATER' | translate }}: </div>
                            </div>
                            <div class="col-6">
                                <div class="org-info-value">{{fileData.create_user}}</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <div class="notification-info-title">{{ 'SIZE' | translate }}: </div>
                            </div>
                            <div class="col-6">
                                <div class="org-info-value">{{ convertationToMb(fileData.size) }}</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <div class="notification-info-title">{{ 'FORMAT' | translate }}: </div>
                            </div>
                            <div class="col-6">
                                <div class="org-info-value">{{fileData.extension}}</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <div class="notification-info-title">{{ 'DOUNLOAD_LINK' | translate }}: </div>
                            </div>
                            <div class="col-6">
                                <a type="button" class="org-info-value link"
                                    (click)="downloadFile(fileData.file_id, fileData.name)">{{ 'DOWNLOAD_FILE' | translate }}
                                </a>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <div class="notification-info-title">Срок действия файла: </div>
                            </div>
                            <div class="col-6">
                                <div class="org-info-value">
                                    <span *ngIf="fileData.meta != null && fileData.meta.valid_to != null">{{ fileData.meta.valid_to | date: 'dd.MM.yyyy'}}</span>
                                    <span *ngIf="fileData.meta == null || fileData.meta.valid_to == null">Нет данных</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <div class="notification-info-title">Категория: </div>
                            </div>
                            <div class="col-6">
                                <div class="org-info-value">
                                    <span *ngIf="fileData.category_name != null">{{fileData.category_name}}</span>
                                    <span *ngIf="fileData.category_name == null">Нет данных</span>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
                <div class="row table-pos">
                    <div class="col-12">
                        <div class="card card-body card-body_table">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <!-- <th scope="col-1"></th> -->
                                        <th scope="col" sortable="name" class="name col-4">Наименования привязанных товаров</th>
                                        <th scope="col" class="name col-2">Штрих-код</th>
                                        <th scope="col" class="name col-4">Наименования привязанного атрибута</th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="fileData.data[0] != null">
                                    <tr class="cursor" *ngFor="let fileLinks of fileData.data"
                                        (click)="productEdit(fileLinks.product_id)">
                                        <td class="name">{{ fileLinks.product_name }}</td>
                                        <td class="name">{{ fileLinks.barcode }}</td>
                                        <td class="name">{{ fileLinks.attributes }}</td>
                                    </tr>
                                </tbody>
                                <tbody >
                                    <td *ngIf="fileData.data[0] == null" class="data-not-found" colspan="4">
                                        <div>{{ 'DATA_NOT_FOUND' | translate }}</div>
                                    </td>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <!-- <div class="col-12">
                        <div class="row mb-2" *ngIf="fileData.extension == 'pdf'">
                            <div class="col-12 contentData">
                                <iframe width="100%" height="400" [src]="fileData.link | safeurl"></iframe>
                            </div>
                        </div>
                    </div> -->
                    <div class="col-12 d-flex btn-pos-c">
                        <button type="button" class="btn btn-light btn-sm btn-pos"   (click)="activeModal.dismiss(false)">{{ 'CLOSE' | translate}}</button>
                        <!-- <button type="button" class="btn btn-primary btn-sm btn-pos" (click)="onEdit(fileData.id);activeModal.dismiss(false)">
                            <i class="bi bi-pencil-square btn-link-info btn-pos-i "></i>{{ 'EDIT' | translate }}
                        </button> -->
                    </div>
                </div>
                <!-- <div class="row" *ngIf="fileData.link && (fileData.extension == 'png' || fileData.extension == 'jpg')">
                    <div class="col-12 image-box">
                        <div class="file-img">
                            <img *ngIf="fileData.link" src="{{ fileData.link }}" alt="logo">
                        </div>
                    </div>
                </div> -->
                <!-- <div class="row" *ngIf="fileData.extension == 'pdf'">
                    <div class="col-12 contentData">
                        <iframe width="100%" height="400" [src]="fileData.link | safeurl"></iframe>
                    </div>
                </div> -->
            </div>
        </div>

    </div>
</div>

<div class="loading" *ngIf="!fileData">
    <div *ngIf="loading">
        <div class="spinner-bars">
            <div class="loadingio-spinner-bars-preLoder-inner">
                <div class="preLoder">
                    <div></div><div></div><div></div><div></div>
                </div>
            </div>
            <div>{{ 'LOADING' | translate }}</div>
        </div>
    </div>
    <div *ngIf="!loading">{{ 'DATA_NOT_FOUND' | translate }}</div>
</div>